/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {action as Éµb,actionInternal as Éµa,computed as Éµc,observable as Éµd} from './lib/mobx-angular/mobx-proxy';